import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "htmlFor"];
import React from "react";
var __jsx = React.createElement;
var ContactInfoLabel = function ContactInfoLabel(_ref) {
  var children = _ref.children,
    htmlFor = _ref.htmlFor,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", _extends({
    className: "font-bold text-xs leading-6 text-black-primary",
    htmlFor: htmlFor
  }, props), children));
};
export default ContactInfoLabel;